import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ArrowRight } from "lucide-react";
import { useState } from "react";
import { Icon } from "@iconify/react";
import bgImage from "../assets/hero.jpg";
gsap.registerPlugin(ScrollTrigger);

export default function HeroSection() {
  const [menuActive, setMenuActive] = useState(false);
  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  const sectionRef = useRef(null);
  const headingRef = useRef(null);
  const imageRef = useRef(null);
  const subHeadingRef = useRef(null);
  const cardsRef = useRef([]);
  const appButton = useRef(null);
  const textCircleRef = useRef();
  const topHeader = useRef(null);
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from(headingRef.current, {
        opacity: 0,
        y: 50,
        duration: 1.2,
        ease: "power3.out",
      });

      gsap.from(subHeadingRef.current, {
        opacity: 0,
        x: 60,
        duration: 1.2,
        ease: "power2.inOut",
      });

      gsap.from(appButton.current, {
        opacity: 0,
        x: 75,
        duration: 1.2,
        ease: "power2.zoomIn",
      });

      gsap.from(imageRef.current, {
        opacity: 0,
        x: 80,
        duration: 1.2,
        delay: 0.3,
        ease: "power3.out",
      });
      //       gsap.from(topHeader.current, {
      //   opacity: 0,
      //   y: 30,
      //   duration: 1.2,
      //   delay: 0.3,
      //   ease: "power3.out",
      // });

      // gsap.from(cardsRef.current, {
      //   scrollTrigger: {
      //     trigger: sectionRef.current,
      //     start: "top 80%",
      //   },
      //   opacity: 0,
      //   y: 40,
      //   duration: 1,
      //   stagger: 0.2,
      //   ease: "power3.out",
      // });

      // Circular Text Rotation
      gsap.to(textCircleRef.current, {
        rotation: 360,
        duration: 15,
        repeat: -1,
        ease: "linear",
        transformOrigin: "center center",
      });

    }, sectionRef);

    return () => ctx.revert();
  }, []);

  useEffect(() => {
    // ===== Make header sticky after scrolling past hero start =====
    const trigger = ScrollTrigger.create({
      trigger: sectionRef.current,
      start: "top top",
      end: "bottom top",
      onUpdate: (self) => {
        setIsFixed(self.progress > 0.05); // if scrolls slightly down
      },
    });

    return () => trigger.kill();
  }, []);

  // const cards = [
  //   {
  //     id: 1,
  //     icon: "mdi:chart-line",
  //     title: "AI Confidence Analysis",
  //     subTitle: "Our AI studies tone, expressions, and body language during interviews to help recruiters assess confidence, communication, and cultural fit."
  //   },
  //   {
  //     id: 2,
  //     icon: "material-symbols:interactive-space",
  //     title: "AI Interview Practice",
  //     subTitle: "Candidates can practice real interview simulations with AI, improving confidence and readiness before facing actual recruiters."
  //   },
  //   {
  //     id: 3,
  //     icon: "material-symbols:wand-stars-outline",
  //     title: "AI-Generated Job & Bio Descriptions",
  //     subTitle: "Creating precise and appealing job descriptions or bios is effortless with AI. Our tool crafts professional content that saves time and stands out."
  //   },
  //   {
  //     id: 4,
  //     icon: "mdi:database-outline",
  //     title: "Built-In Audio & Video Interview Scheduling",
  //     subTitle: "Employers and candidates can easily schedule and conduct interviews within the app, smoothly, reliably, and stress-free."
  //   },
  // ];

  return (
    // <section
    //   ref={sectionRef}
    //   className="w-full bg-cover bg-center bg-no-repeat bg-gradient-to-r from-white/10 via-gray-100 to-neutral-950"
    //   style={{
    //     backgroundImage: ` linear-gradient(to right,  transparent 0%,  transparent 75%,   black 75%,  black 100% ),
    //   url('https://media.istockphoto.com/id/1454026499/photo/marble-granite-white-background-wall-surface-black-pattern-graphic-abstract-light-elegant.jpg?s=612x612&w=0&k=20&c=m8DFYhT8g9MjJCcxesVYSP_lQk95NfFwyLzznV4oUYM=') `,
    //     backgroundSize: "cover",
    //     backgroundPosition: "center",
    //     backgroundRepeat: "no-repeat",
    //   }}
    // >

    <section ref={sectionRef}
      className=" w-full  bg-cover  bg-center  bg-no-repeat lg:bg-[linear-gradient(to_right,transparent_0%,transparent_75%,black_75%,black_100%),url('https://media.istockphoto.com/id/1454026499/photo/marble-granite-white-background-wall-surface-black-pattern-graphic-abstract-light-elegant.jpg?s=612x612&w=0&k=20&c=m8DFYhT8g9MjJCcxesVYSP_lQk95NfFwyLzznV4oUYM=')]
      bg-[url('https://media.istockphoto.com/id/1454026499/photo/marble-granite-white-background-wall-surface-black-pattern-graphic-abstract-light-elegant.jpg?s=612x612&w=0&k=20&c=m8DFYhT8g9MjJCcxesVYSP_lQk95NfFwyLzznV4oUYM=')]">
      <header className={`transition-all duration-700 z-50 ${isFixed
        ? "fixed top-0 left-0 w-full bg-white/50 backdrop-blur-md shadow-md"
        : "absolute top-0 left-0 w-full bg-transparent "
        }`}>
        <div className="flex justify-between items-center py-4 px-6 lg:px-16 bg-transparent">
          {/* LOGO */}
          <a href="/" className="text-2xl font-bold">
            <img
              className={`transition-all duration-500 ${isFixed ? "w-44" : "w-48"}`}
              src={require("../assets/viskohr-logo.webp")}
              // src="https://viskohr.com/static/media/Visko_logo.096d8e010f7b30432a17.png"
              alt="Visko HR"
            />
          </a>

          {/* NAV LINKS */}
          <nav
            className={`hidden md:flex gap-8 text-base text-gray-800 font-semibold ${menuActive ? "navbar-mobile" : ""
              }`}
          >
            {["Home", "About", "Services", "Features", "Our Products", "Contact"].map(
              (item) => (
                <a
                  key={item}
                  href={`#${item.toLowerCase().replace(" ", "")}`}
                  onClick={(e) => {
                    e.preventDefault();
                    document
                      .querySelector(`#${item.toLowerCase().replace(" ", "")}`)
                      ?.scrollIntoView({ behavior: "smooth" });
                    setMenuActive(false);
                  }}
                  className="hover:text-[#F26A33] cursor-pointer hover:scale-105 transition-transform hover:underline"
                >
                  {item}
                </a>
              )
            )}
          </nav>

          {/* CTA BUTTON */}
          <div className="flex flex-col md:flex-row gap-3 md:gap-8 md:justify-end">
            <a href="https://viskoit.ae/" target="_blank" rel="noreferrer"
              className="relative flex-1 md:flex-none md:w-48 
                                inline-flex items-center justify-center 
                                px-6 py-2.5 
                                overflow-hidden tracking-tighter text-white bg-gray-600 rounded-md group"
            >
              <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-orange-600 rounded-full group-hover:w-56 group-hover:h-56"></span>
              <span className="absolute bottom-0 left-0 h-full -ml-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-auto h-full opacity-100 object-stretch" viewBox="0 0 487 487" >
                  <path fillOpacity=".1" fillRule="nonzero" fill="#FFF" d="M0 .3c67 2.1 134.1 4.3 186.3 37 52.2 32.7 89.6 95.8 112.8 150.6 23.2 54.8 32.3 101.4 61.2 149.9 28.9 48.4 77.7 98.8 126.4 149.2H0V.3z" ></path>
                </svg>
              </span>
              <span className="absolute top-0 right-0 w-12 h-full -mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="object-cover w-full h-full" viewBox="0 0 487 487" >
                  <path fillOpacity=".1" fillRule="nonzero" fill="#FFF" d="M487 486.7c-66.1-3.6-132.3-7.3-186.3-37s-95.9-85.3-126.2-137.2c-30.4-51.8-49.3-99.9-76.5-151.4C70.9 109.6 35.6 54.8.3 0H487v486.7z" ></path>
                </svg>
              </span>
              <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-gray-200"></span>
              <span className="relative text-base font-semibold"> IT Solutions</span>
            </a>
            <a href="https://remarkhr.com/" target="_blank" rel="noreferrer"
              className="relative flex-1 md:flex-none md:w-48 
                                inline-flex items-center justify-center 
                                px-6 py-2.5 
                                overflow-hidden tracking-tighter text-white bg-orange-600 rounded-md group">
              <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-gray-600 rounded-full group-hover:w-56 group-hover:h-56"></span>
              <span className="absolute bottom-0 left-0 h-full -ml-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="w-auto h-full opacity-100 object-stretch" viewBox="0 0 487 487" >
                  <path fillOpacity=".1" fillRule="nonzero" fill="#FFF" d="M0 .3c67 2.1 134.1 4.3 186.3 37 52.2 32.7 89.6 95.8 112.8 150.6 23.2 54.8 32.3 101.4 61.2 149.9 28.9 48.4 77.7 98.8 126.4 149.2H0V.3z" ></path>
                </svg>
              </span>
              <span className="absolute top-0 right-0 w-12 h-full -mr-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="object-cover w-full h-full" viewBox="0 0 487 487" >
                  <path fillOpacity=".1" fillRule="nonzero" fill="#FFF" d="M487 486.7c-66.1-3.6-132.3-7.3-186.3-37s-95.9-85.3-126.2-137.2c-30.4-51.8-49.3-99.9-76.5-151.4C70.9 109.6 35.6 54.8.3 0H487v486.7z" ></path>
                </svg>
              </span>
              <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-gray-200"></span>
              <span className="relative text-base font-semibold">Get Started</span>
            </a>
          </div>
        </div>
      </header>

      {/* ====== HERO SECTION ====== */}
      <div className="max-w-screen-2xl mx-auto flex flex-col lg:flex-row justify-between px-4 sm:px-8 lg:px-6 py-32 sm:py-16 lg:py-48 gap-10 ">
        {/* LEFT TEXT */}
        <div className=" text-left md:pt-20">
          <h1
            ref={headingRef}
            // className="text-4xl sm:text-5xl md:text-[85px] font-semibold text-black leading-22 underline"
            className="text-3xl sm:text-5xl md:text-6xl lg:text-[60px] xl:text-[80px] font-semibold text-black leading-tight md:leading-[1.1]"

          >
            Smart AI Hiring Solution
            <br />
            <span className="underline ">
              for Dubai’s Competitive
            </span>
            <br />
            <span className="underline ">
              Job Market
            </span>
          </h1>

          <p ref={subHeadingRef} className="text-gray-600 mt-6 max-w-md text-sm sm:text-base leading-relaxed">
            At Visko HR, we help UAE businesses and professionals hire smarter with AI-powered recruitment solutions. From intelligent talent matching to automated interviews, we make hiring faster, more accurate, and future-ready across Dubai and the UAE.</p>

          <div ref={appButton} className="md:mt-8 flex items-center gap-4">
            {/* APP STORE BUTTONS */}
            <div className="mt-8 flex flex-wrap items-center gap-4">
              <a href="https://play.google.com/store/apps/details?id=com.remark.viskohr"><img
                src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                alt="Get it on Google Play"
                className="h-12 sm:h-14 cursor-pointer hover:scale-105 transition-transform "
              /></a>
              <a href="https://apps.apple.com/in/app/remark-job-recruiter-app/id6475642568"><img
                src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                alt="Download on the App Store"
                className="h-12 sm:h-14 cursor-pointer hover:scale-105 transition-transform "
              /></a>
            </div>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <div
          ref={imageRef}
          className="flex-1 relative flex justify-center items-center z-10"
        >
          <div className="xl:-mr-32 relative rounded-[2rem] w-full max-w-md sm:max-w-lg md:max-w-xl lg:max-w-2xl">
            <img
              src="https://api.visko.group/public/assets/img/uploads/ticket-docs/1767420911_9f03ddb5fcff8df7ea76.webp"
              // src={require("../assets/hero3.jpg")}
              alt="Team"
              className="rounded-xl hover:rounded-none duration-500 rounded-br-[200px] sm:rounded-br-[280px] lg:rounded-br-[240px] xl:rounded-br-[320px] w-full h-auto object-cover"
            />
            <div className="absolute xl:top-96 lg:top-60 top-80 md:left-2 z-20 -translate-x-1/2 bg-white rounded-full p-4 shadow-lg
            left-1/2 
            
            ">
              <svg ref={textCircleRef} viewBox="0 0 100 100" className="xl:w-40 xl:h-40 lg:w-28 lg:h-28 w-40 h-40 rounded-full bg- ">
                <defs>
                  <path
                    id="circlePath"
                    d="M 50, 50 m -35, 0 a 35,35 0 1,1 70,0 a 35,35 0 1,1 -70,0"
                  />
                </defs>
                <text className="bg-white" fill="#000" fontSize="13" letterSpacing="1">
                  make this background black and text is white
                  <textPath href="#circlePath" className="">
                    ● FEATURED ROLE ● APPLY NOW ● FEATURED ROLE ●
                  </textPath>
                </text>
              </svg>
              <div className="absolute inset-0 flex items-center justify-center">
                <img
                  className="w-10 sm:w-12"
                  src={require("../assets/viskologo.webp")}
                  // src="https://viskohr.com/static/media/Visko_logo.096d8e010f7b30432a17.png"
                  alt="Visko HR"
                />
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT IMAGE */}
      </div>
    </section>
  );
}